import { Unplug } from "lucide-react";
import { cn } from "@/lib/utils";

export default function ProjectOfflineState({
  className,
  message,
}: {
  className?: string;
  message?: string;
}) {
  return (
    <div
      className={cn(
        "flex h-full w-full flex-col items-center justify-center gap-4 bg-background px-6 text-center",
        className,
      )}
    >
      <div className="rounded-full border border-muted-foreground p-4">
        <Unplug className="h-10 w-10 text-muted-foreground" />
      </div>
      <p className="text-lg font-medium text-muted-foreground">
        {message ?? "Stone is Offline"}
      </p>
    </div>
  );
}
